import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import Button from '@ts-core/components/Button';
import ExercisesSelector, { useExercisesSelector } from 'modules/exercises/components/ExercisesSelector';

import CourseSelector, { useCourseSelector } from 'modules/courses/components/CourseSelector';

import { Exercise } from '../../types';

interface ImportExercisesFromCourseProps {
  onImportExercises: (exercises: Exercise[]) => void;
  importingExercises: boolean;
}

const ImportExercisesFromCourse = (props: ImportExercisesFromCourseProps) => {
  const { importingExercises, onImportExercises } = props;
  const intl = useIntl();

  const { selectedCourse, props: courseSelectorProps } = useCourseSelector({
    excludedCourses: [],
  });
  const selectedCourseId = (selectedCourse as any)?._id;

  const { selectorProps, selectedExercises } = useExercisesSelector({ courseId: selectedCourseId });

  const handleImportExercises = useCallback(() => {
    if (selectedExercises.length > 0) {
      onImportExercises(selectedExercises);
    }
  }, [selectedExercises, onImportExercises]);

  return (
    <Box width="100%" minHeight={200} display="flex" flexDirection="column">
      <CourseSelector {...courseSelectorProps} />
      {selectedCourse && selectedCourseId !== '' && (
        <Box mt={2} sx={{ overflowY: 'scroll' }}>
          <ExercisesSelector {...selectorProps} />
        </Box>
      )}
      <Box flexGrow={1} />
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end" py={2} px={2}>
        <Button onClick={handleImportExercises} loading={importingExercises} disabled={selectedExercises.length === 0} variant="contained">
          {intl.formatMessage({ id: 'button.copyExercises.title' })}
        </Button>
      </Box>
    </Box>
  );
};

export default ImportExercisesFromCourse;
